import { Inject, Injectable } from '@angular/core';
import { SharedService } from './shared.service';
declare let $: any;
@Injectable({
    providedIn: 'root',
})
export class CustomThemeUtility {
    constructor( private shared : SharedService) {}
    
    resolveLogo(themeData?:any){
       const theme = themeData ? themeData : JSON.parse(localStorage.getItem('theme'));
       return theme ? theme.brandLogo :`assets/images/yokahu-logo.png`;  
    }

    addCustomCss(theme){
        const style = `.insurer-theme .header { background: ${theme.headerFooterColor} !important; }
        .insurer-theme .menu-section{background-color: ${theme.headerFooterColor} !important;}
        .insurer-theme .footer-section{background: ${theme.headerFooterColor} !important;}
        .insurer-theme .mat-progress-bar-fill:after{background-color: ${theme.primaryBrandColor } !important ;}
        .insurer-theme .mat-progress-bar-buffer { background-color : ${theme.secondaryBrandColor} !important;}
        .insurer-theme .mat-accent .mat-slider-thumb{background-color:${theme.primaryBrandColor } !important ;}
        .insurer-theme .mat-accent .mat-slider-thumb-label{background-color:${theme.primaryBrandColor } !important ;}
        .insurer-theme .mat-slider-thumb-label:before{background :${theme.primaryBrandColor } !important ;}
        .insurer-theme .primary-btn {background-color: ${theme.primaryBrandColor } !important ;}
        .insurer-theme .primary-btn-action {color : ${theme.primaryBrandColor} !important ;}
        .insurer-theme .brand-link{color:${theme.linkColor} !important; }
        .insurer-theme app-policy-details .header {border-bottom: 12px solid ${theme.primaryBrandColor } !important;}
        .insurer-theme .mat-checkbox-checked.mat-primary .mat-checkbox-background{background-color: ${theme.primaryBrandColor} !important;}
        .insurer-theme .mat-mdc-form-field-label {color:  ${theme.secondaryBrandColor} !important;}
        .insurer-theme .mat-mdc-form-field.mat-focused .mat-mdc-form-field-ripple {background-color:  ${theme.secondaryBrandColor} !important;}
        .insurer-theme .mat.mdc-form-field .mat-select .mat-select-arrow {color:  ${theme.secondaryBrandColor} !important;}
        .insurer-theme .mat-tab-group.mat-primary .mat-ink-bar{background-color:${theme.secondaryBrandColor} !important ;}
        .insurer-theme .aboutpolicy-tabs .mat-tab-group.mat-primary .mat-ink-bar{background-color:${theme.secondaryBrandColor} !important ;}
        .insurer-theme app-download-summary .main-header {border-bottom: 12px solid ${theme.primaryBrandColor} !important;}
        .insurer-theme app-policy-summary .Policy_schedule-form{border-top: 12px solid ${theme.primaryBrandColor} !important;}
        .insurer-theme .mat-option.mat-selected .mat-option-text{color : ${theme.primaryBrandColor} !important;}
        .insurer-theme app-policy-summary .header-text{border-bottom: 12px solid ${theme.primaryBrandColor} !important;}
        .insurer-theme .mat-slide-toggle.mat-checked .mat-slide-toggle-bar{background-color : ${theme.secondaryBrandColor} !important; }
        .insurer-theme .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb{background-color : ${theme.primaryBrandColor} !important; }`
 
        $(document).ready(function(){
            $("style").append(style);
        });
    }

    addClass(theme:any){
        document.querySelector('body').classList.add('insurer-theme');
        this.addCustomCss(theme);
    }

}